import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import Loader from "./components/common/Loader";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import "./styles/index.css";
import "./styles/override.css";
import "./styles/saStyle.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || "https://sso.dev-sheba.xyz",
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "master",
  clientId:
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID ||
    "pg_run_1b463937-ff86-4ba8-bf06-ce346fe08eaa",
});

// export const keycloak = new Keycloak({
//   url: process.env.REACT_APP_KEYCLOAK_URL || "https://sso.sheba.xyz",
//   realm: process.env.REACT_APP_KEYCLOAK_REALM || "master",
//   clientId:
//     process.env.REACT_APP_KEYCLOAK_CLIENT_ID ||
//     "power_genie_d5772f88-5416-454c-99aa-fc9b62c31302",
// });

root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: "check-sso",
      silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
      pkceMethod: "S256",
      checkLoginIframe: false,
    }}
    onEvent={(event, error) => {
      // console.log(error);
    }}
    LoadingComponent={<Loader />}
  >
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ReactKeycloakProvider>
);

reportWebVitals();
